var React = require('react');

function TargetIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#9obmby6rca)","fill":"#8D6CFF","key":0},[React.createElement("path",{"d":"M24 4c11.046 0 20 8.954 20 20s-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4zm0 4C15.163 8 8 15.163 8 24s7.163 16 16 16 16-7.163 16-16S32.837 8 24 8zm0 11a5 5 0 1 1 0 10 5 5 0 0 1 0-10z","key":0}),React.createElement("path",{"d":"M13 22H0v4h13v-4zM48 22H35v4h13v-4zM26 0h-4v14h4V0zM26 34h-4v14h4V34z","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"9obmby6rca"},React.createElement("path",{"fill":"#fff","d":"M0 0h48v48H0z"})))]);
}

TargetIcon.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = TargetIcon;

TargetIcon.default = TargetIcon;
